export const contactsData = {
    email: 'ali1701@cseku.ac.bd',
    phone: '+8801521301056',
    address: 'Dhaka, Bangladesh',

    sheetAPI: 'ali1701@cseku.ac.bd'
}